import API_ENDPOINTS from "../config/apiEndpoints";
import { requestWithAuth } from "./apiClient";

export const apiEmpleadosService = {
  getAllPageable: (idEmpresa, page, size) => {
    return API_ENDPOINTS.EMPLEADO.ALL(idEmpresa, page, size); // Devuelve directamente la URL
  },
  get: async (idEmpresa, idEmpleado) => {
    const response = await requestWithAuth(
      API_ENDPOINTS.EMPLEADO.ONE(idEmpresa, idEmpleado),
      { method: "GET" }
    );
    return response.json();
  },
  getAll: async (idEmpresa, page, size) => {
    const response = await requestWithAuth(
      API_ENDPOINTS.EMPLEADO.ALL(idEmpresa, page, size),
      { method: "GET" }
    );
    if (!response.ok) {
      throw new Error("Error");
    }

    return response.json();
  },

  getAllFiltered: async (
    idEmpresa,
    centroId,
    departamentoId,
    horarioId,
    fechaBaja,
    order,
    page,
    size
  ) => {
    let url = API_ENDPOINTS.EMPLEADO.ALL(idEmpresa, page, size);

    if (centroId !== null && centroId !== "") {
      url += `&centro=${centroId}`;
    }

    if (departamentoId !== null && departamentoId !== "") {
      url += `&departamento=${departamentoId}`;
    }

    if (horarioId !== null && horarioId !== "") {
      url += `&horario=${horarioId}`;
    }
    if (fechaBaja !== null && fechaBaja !== "") {
      url += `&fechaBaja=${fechaBaja}`;
    }
    if (order !== null && order !== "") {
      url += `&sort=apellidos,${order}`;
    } else {
      url += `&sort=apellidos,asc`;
    }

    const response = await requestWithAuth(url, { method: "GET" });
    if (!response.ok) {
      throw new Error("Error");
    }

    return response.json();
  },
  getAllByDepartamento: async (idDepartamento, page, size) => {
    const response = await requestWithAuth(
      API_ENDPOINTS.EMPLEADO.ALL_BY_DEPARTAMENTO(idDepartamento, page, size),
      { method: "GET" }
    );
    if (!response.ok) {
      throw new Error("Error");
    }

    return response.json();
  },
  createEmpleado: async function (json) {
    const response = await requestWithAuth(API_ENDPOINTS.EMPLEADO.CREATE, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(json),
    });

let body;
  try {
    body = await response.json();
  } catch (e) {
    body = null;
  }

  if (!response.ok) {

    const error = new Error(body?.error_code );
    error.status = response.status;
    error.error_code = body?.error_code;
    error.body = body?.message;

    throw error;
  }

  return body;
  },
  updateEmpleado: async function (empleadoId, json) {
    const response = await requestWithAuth(
      API_ENDPOINTS.EMPLEADO.UPDATE_ONE(empleadoId),
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(json),
      }
    );

    return response.json();
  },
  updateEmpleadoHorario: async function (empresaId, empleadoId, idhorario) {
    const response = await requestWithAuth(
      API_ENDPOINTS.EMPLEADO.UPDATE_HORARIO(empresaId, empleadoId),
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: idhorario,
      }
    );

    return response.json();
  },
  setPasswordEmpleado: async function (empleadoId, password) {
    const response = await requestWithAuth(
      API_ENDPOINTS.EMPLEADO.UPDATE_PASSWORD(empleadoId),
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: password,
      }
    );

    return response.json();
  },
};
